import { render, staticRenderFns } from "./UpdatePresonalInfo.vue?vue&type=template&id=2f01341b"
import script from "./UpdatePresonalInfo.vue?vue&type=script&lang=js"
export * from "./UpdatePresonalInfo.vue?vue&type=script&lang=js"
import style0 from "./UpdatePresonalInfo.vue?vue&type=style&index=0&id=2f01341b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports